// The app's look: which base stylesheet is under our own (theme.css). The
// default is plain Bootstrap; the others are Bootswatch restyles of it, offered
// as an experiment ("beta"): some screens may look off in them. The files are
// in public/looks/ (see "Looks" in ARCHITECTURE.md), and the page's <link
// id="ordo-look"> points at the chosen one. Independent of the accent color
// (theme.js), which goes on top of any of them.
export const LOOKS = [
    {id: "default", label: "Padrão", description: "o de sempre", beta: false},
    {id: "flatly", label: "Flatly", description: "plano e limpo", beta: true},
    {id: "materia", label: "Materia", description: "estilo Material", beta: true},
    {id: "sketchy", label: "Sketchy", description: "desenhado à mão", beta: true},
];

export const DEFAULT_LOOK = LOOKS[0].id;
const KEY = "ordo-look";
const CHANGED = "ordo:look";

const known = (id) => LOOKS.some((look) => look.id === id);

/** The saved choice, or the default (also when storage is unavailable). */
export const savedLook = () => {
    try {
        const id = localStorage.getItem(KEY);
        return known(id) ? /** @type {string} */ (id) : DEFAULT_LOOK;
    } catch {
        return DEFAULT_LOOK;
    }
};

const href = (id) => `${process.env.PUBLIC_URL || ""}/looks/${id}.css`;

/** Shows a look right away; unknown ids fall back to the default. */
export const applyLook = (id) => {
    const wanted = known(id) ? id : DEFAULT_LOOK;
    const link = document.getElementById("ordo-look");
    if (link) link.setAttribute("href", href(wanted));
    document.documentElement.setAttribute("data-look", wanted);
    window.dispatchEvent(new Event(CHANGED));
};

/** What is showing now. */
export const currentLook = () => {
    const id = document.documentElement.getAttribute("data-look");
    return known(id) ? /** @type {string} */ (id) : DEFAULT_LOOK;
};

/** Subscribes to every change of the look on show; returns the way to stop. */
export const onLookChanged = (callback) => {
    window.addEventListener(CHANGED, callback);
    return () => window.removeEventListener(CHANGED, callback);
};

/** Shows a look and remembers it for next time. */
export const chooseLook = (id) => {
    applyLook(id);
    try {
        localStorage.setItem(KEY, known(id) ? id : DEFAULT_LOOK);
    } catch {
        // Private window or blocked storage: the choice lasts until the page closes.
    }
};

/**
 * The provider's saved look, as the server has it, is what the app wears:
 * show it and keep it in the browser too. Nothing saved means the default.
 */
export const syncLook = (id) => chooseLook(id ?? DEFAULT_LOOK);
